const home = {
  heroTitle: '岛国精品',
  heroSubtitle: '日本原装进口商品精选平台',
  heroDescription: '汇聚日本美妆护肤、食品零食、家居日用等多品类精选好物，品质严选、正品保障，支持直邮到家，让您轻松享受来自日本的高品质生活体验。',
  heroCTA: '立即浏览全品类特惠专区',
  heroSecondaryCTA: '了解更多',
  featuredCategories: '精选品类',
  featuredCategoriesDesc: '从美妆护肤到家居日用，发现更多日本好物',
  hotProducts: '热门推荐',
  hotProductsDesc: '精选日本人气商品，品质保证，直邮到家',
  brandStoryTitle: '品牌故事',
  brandStoryDesc: '岛国精品成立于2018年，致力于为中国消费者带来最纯正的日本商品体验。我们与超过200家日本品牌建立直接合作关系，每一件商品都经过严格品质筛选，确保您收到的是真正来自日本的正品好物。',
  brandStoryCTA: '了解我们的故事',
  statsProducts: '精选商品',
  statsBrands: '合作品牌',
  statsCustomers: '服务用户',
  statsCountries: '覆盖城市',
  faqTitle: '常见问题',
  faqDesc: '关于岛国精品的常见疑问解答',
  newsletterTitle: '订阅岛国精品资讯',
  newsletterDesc: '第一时间获取新品上架、限时特惠和日本好物推荐',
};

export default home;